import { useMemo } from 'react'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import { useSelector } from 'react-redux'

import { useAuth } from './use-auth'
import { useRoles } from './use-roles'

import { uniqueArray } from 'modules'
import { SpaceType } from 'app/types'

const sortByName = (spaces: Array<SpaceType>) =>
    uniqueArray<SpaceType, SpaceType>(
        spaces
            .filter(Boolean)
            .sort((a, b) => (a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1))
    )

export const useOrgSpaces = () => {
    const { isAdmin } = useRoles()
    const { orgId, uid } = useAuth()

    useFirestoreConnect({
        collection: 'spaces',
        where: isAdmin
            ? [`organizationId`, '==', orgId]
            : [
                  [`organizationId`, '==', orgId],
                  ['isPrivate', '!=', true]
              ],
        storeAs: 'orgSpaces'
    })

    const orgSpaces = useSelector(state => state.firestore?.data.orgSpaces)

    const orgSpacesData = Object.values<SpaceType>(orgSpaces || {}).filter(Boolean)

    return useMemo(
        () => ({
            isOrgSpacesLoading: !isLoaded(orgSpaces),
            orgSpacesData,
            orgSpaces: sortByName(orgSpacesData.filter(({ members }) => !members?.[uid]))
        }),
        [orgSpacesData, uid, orgSpaces]
    )
}
